import { hotelCrudConfig, type Hotel } from '@/config/objects/hotels';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Hotel create/edit form page
 */
export function HotelFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // If id is 'new', treat as create mode (id = undefined)
  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  /**
   * Handle successful form submission
   */
  const handleSuccess = (hotel: Hotel) => {
    // Navigate to the hotel detail page
    navigate(`/hotels/${hotel.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Hotels', href: '/hotels' },
        { label: 'Hotel', href: `/hotels/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Hotels', href: '/hotels' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={hotelCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
